import * as React from 'react'
import { Grid, Paper, Typography, makeStyles, Box, TableContainer, Table, TableHead, TableRow, TableCell, TextField, MenuItem, TableBody, createStyles, Theme } from '@material-ui/core'
import { getIndexData, listChannelRank } from '../../utils/api'
import { useQuery } from 'react-query'
import { formatPrice } from '../../utils'
import { StyledTableCell } from '../../components/CustomTable'
import moment from 'moment'
const useStyles = makeStyles((theme: Theme) => createStyles({
    box: {
        padding: '16px',
        [theme.breakpoints.down('xs')]: {
            padding: '4px',
        }
    },
    data: {
        fontSize: '50px',
        fontWeight: 500,
        textAlign: 'center',
        [theme.breakpoints.down('xs')]: {
            fontSize: '28px'
        }
    },
    label: {
        marginTop: '8px',
        textAlign: 'center',
        fontSize: '14px',
        [theme.breakpoints.down('xs')]: {
            marginTop: '4px',
        }
    }
}))

type IndexData = {
    total: { vipCount: number, userCount: number, orderCount: number, videoPlayCount: number },
    yesterday: { vipCount: number, userCount: number, orderCount: number, videoPlayCount: number, activeUserCount: number, paymentAmount: number, incomeAmount: number },
    today: { vipCount: number, userCount: number, orderCount: number, videoPlayCount: number, activeUserCount: number, paymentAmount: number, incomeAmount: number },
    order: {
        initialInterviewCount: number,
        coachingCount: number,
        vipCount: number,
        courseCount: number
    },
    income: {
        totalPaymentAmount: number,
        totalIncomeAmount: number,
        coinCount: number
    }
}

const Home = () => {
    const classes = useStyles()
    const { data } = useQuery<IndexData>('indexdata', getIndexData, { refetchInterval: 60 * 1000 })
    const [internalMonth, setInternalMonth] = React.useState('this')
    const [externalMonth, setExternalMonth] = React.useState('this')
    const { data: internalChannelRank } = useQuery<SalesChannel[]>(['listchannelrank', 'internal', internalMonth], () => listChannelRank(internalMonth, 'internal'))
    const { data: externalChannelRank } = useQuery<SalesChannel[]>(['listchannelrank', 'external', externalMonth], () => listChannelRank(externalMonth, 'external'))

    const computedWidth = (num: number, total: number) => {
        let width = Math.floor(num / total * 100)
        if (width < 10) {
            width = 10
        }
        return `${width}%`
    }

    return <React.Fragment>
        <Box p={2}>
            <Typography variant="subtitle1">今日数据</Typography>
        </Box>
        <Grid container spacing={3}>
            <Grid item xs={6} md={3}>
                <Paper className={classes.box} style={{ backgroundColor: '#fffed3' }}>
                    <Typography className={classes.data}>
                        {data?.today.userCount}
                    </Typography>
                    <Typography className={classes.label}>
                        新增注册用户数
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3} >
                <Paper className={classes.box} style={{ backgroundColor: '#fffed3' }}>
                    <Typography className={classes.data}>
                        {data?.today.vipCount}
                    </Typography>
                    <Typography className={classes.label}>
                        新增VIP会员数
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3} >
                <Paper className={classes.box} style={{ backgroundColor: '#fffed3' }}>
                    <Typography className={classes.data}>
                        {data?.today.orderCount}
                    </Typography>
                    <Typography className={classes.label}>
                        新增订单数
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3} >
                <Paper className={classes.box} style={{ backgroundColor: '#fffed3' }}>
                    <Typography className={classes.data}>
                        {data?.today.videoPlayCount}
                    </Typography>
                    <Typography className={classes.label}>
                        视频播放次数
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3} >
                <Paper className={classes.box} style={{ backgroundColor: '#fffed3' }}>
                    <Typography className={classes.data}>
                        {data?.today.activeUserCount}
                    </Typography>
                    <Typography className={classes.label}>
                        活跃用户数
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3} >
                <Paper className={classes.box} style={{ backgroundColor: '#fffed3' }}>
                    <Typography className={classes.data}>
                        {formatPrice(data?.today.paymentAmount)}
                    </Typography>
                    <Typography className={classes.label}>
                        用户支付
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3} >
                <Paper className={classes.box} style={{ backgroundColor: '#fffed3' }}>
                    <Typography className={classes.data}>
                        {formatPrice(data?.today.incomeAmount)}
                    </Typography>
                    <Typography className={classes.label}>
                        收入(估算)
                    </Typography>
                </Paper>
            </Grid>
        </Grid>

        <Box p={2}>
            <Typography variant="subtitle1">昨日数据({moment().subtract(1, 'days').format('YYYY/MM/DD')})</Typography>
        </Box>
        <Grid container spacing={3}>
            <Grid item xs={6} md={3}>
                <Paper className={classes.box} style={{ backgroundColor: '#d2f9ff' }}>
                    <Typography className={classes.data}>
                        {data?.yesterday.userCount}
                    </Typography>
                    <Typography className={classes.label}>
                        新增注册用户数
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3} >
                <Paper className={classes.box} style={{ backgroundColor: '#d2f9ff' }}>
                    <Typography className={classes.data}>
                        {data?.yesterday.vipCount}
                    </Typography>
                    <Typography className={classes.label}>
                        新增VIP会员数
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3} >
                <Paper className={classes.box} style={{ backgroundColor: '#d2f9ff' }}>
                    <Typography className={classes.data}>
                        {data?.yesterday.orderCount}
                    </Typography>
                    <Typography className={classes.label}>
                        新增订单数
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3} >
                <Paper className={classes.box} style={{ backgroundColor: '#d2f9ff' }}>
                    <Typography className={classes.data}>
                        {data?.yesterday.videoPlayCount}
                    </Typography>
                    <Typography className={classes.label}>
                        视频播放次数
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3} >
                <Paper className={classes.box} style={{ backgroundColor: '#d2f9ff' }}>
                    <Typography className={classes.data}>
                        {data?.yesterday.activeUserCount}
                    </Typography>
                    <Typography className={classes.label}>
                        活跃用户数
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3} >
                <Paper className={classes.box} style={{ backgroundColor: '#d2f9ff' }}>
                    <Typography className={classes.data}>
                        {formatPrice(data?.yesterday.paymentAmount)}
                    </Typography>
                    <Typography className={classes.label}>
                        用户支付
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3} >
                <Paper className={classes.box} style={{ backgroundColor: '#d2f9ff' }}>
                    <Typography className={classes.data}>
                        {formatPrice(data?.yesterday.incomeAmount)}
                    </Typography>
                    <Typography className={classes.label}>
                        收入(估算)
                    </Typography>
                </Paper>
            </Grid>
        </Grid>

        <Box p={2}>
            <Typography variant="subtitle1">Overall</Typography>
        </Box>
        <Grid container spacing={3}>
            <Grid item xs={6} md={3}>
                <Paper className={classes.box} style={{ backgroundColor: '#ffdbcb' }}>
                    <Typography className={classes.data}>
                        {data?.total.userCount}
                    </Typography>
                    <Typography className={classes.label}>
                        总注册用户数
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3}>
                <Paper className={classes.box} style={{ backgroundColor: '#ffdbcb' }}>
                    <Typography className={classes.data}>
                        {data?.total.vipCount}
                    </Typography>
                    <Typography className={classes.label}>
                        总VIP会员数
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3}>
                <Paper className={classes.box} style={{ backgroundColor: '#ffdbcb' }}>
                    <Typography className={classes.data}>
                        {data?.total.orderCount}
                    </Typography>
                    <Typography className={classes.label}>
                        总订单数
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3}>
                <Paper className={classes.box} style={{ backgroundColor: '#ffdbcb' }}>
                    <Typography className={classes.data}>
                        {data?.total.videoPlayCount}
                    </Typography>
                    <Typography className={classes.label}>
                        总视频播放次数
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
                <Paper className={classes.box} style={{ backgroundColor: '#ffdbcb' }}>
                    <Box>
                        <Typography className={classes.data}>
                            {formatPrice(data?.income.totalPaymentAmount)}
                        </Typography>
                        <Typography className={classes.label}>
                            累计用户支付
                    </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-around">
                        <Box className={classes.box}>
                            <Typography className={classes.data}>
                                {data ? formatPrice(data.income.totalIncomeAmount) : 0}
                            </Typography>
                            <Typography className={classes.label}>
                                累计总收入
                        </Typography>
                        </Box>
                        <Box className={classes.box}>
                            <Typography className={classes.data}>
                                {data ? formatPrice(Math.floor(data.income.totalPaymentAmount) - Math.floor(data.income.totalIncomeAmount)) : 0}
                            </Typography>
                            <Typography className={classes.label}>
                                累计平台扣除
                        </Typography>
                        </Box>
                    </Box>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3}>
                <Paper className={classes.box} style={{ backgroundColor: '#ffdbcb' }}>
                    <Typography className={classes.data}>
                        {formatPrice(data?.income.coinCount)}
                    </Typography>
                    <Typography className={classes.label}>
                        爱豆存量
                        </Typography>
                </Paper>
            </Grid>
        </Grid>




        <Box p={2}>
            <Typography variant="subtitle1">分类总订单数据</Typography>
        </Box>
        <Grid container spacing={3}>
            <Grid item xs={6} md={3}>
                <Paper className={classes.box} style={{ backgroundColor: '#d8eaff' }}>
                    <Typography className={classes.data}>
                        {data?.order.initialInterviewCount}
                    </Typography>
                    <Typography className={classes.label}>
                        首次约谈订单数
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3}>
                <Paper className={classes.box} style={{ backgroundColor: '#d8eaff' }}>
                    <Typography className={classes.data}>
                        {data?.order.courseCount}
                    </Typography>
                    <Typography className={classes.label}>
                        线上课程订单数
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3}>
                <Paper className={classes.box} style={{ backgroundColor: '#d8eaff' }}>
                    <Typography className={classes.data}>
                        {data?.order.coachingCount}
                    </Typography>
                    <Typography className={classes.label}>
                        教练订单数
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={6} md={3}>
                <Paper className={classes.box} style={{ backgroundColor: '#d8eaff' }}>
                    <Typography className={classes.data}>
                        {data?.order.vipCount}
                    </Typography>
                    <Typography className={classes.label}>
                        VIP会员订单数
                    </Typography>
                </Paper>
            </Grid>
        </Grid>

        <Box p={2}>
            <Typography variant="subtitle1">渠道排名</Typography>
        </Box>
        <Grid container spacing={3}>
            <Grid md={6} xs={12}>

                <Box p={1.5}>
                    <Paper >
                        <Box p={1.5} display="flex" justifyContent="space-between" bgcolor="#69A9C7" alignItems="center">
                            <Typography style={{ color: '#fff' }}>内部渠道</Typography>
                            <TextField select InputProps={{ disableUnderline: true }} value={internalMonth} size="small" SelectProps={{ disableUnderline: true, style: { color: '#fff' } }} style={{ color: '#fff' }} onChange={event => setInternalMonth(event.target.value)}>
                                <MenuItem value="this">本月</MenuItem>
                                <MenuItem value="last">上月</MenuItem>
                            </TextField>
                        </Box>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>渠道名称</StyledTableCell>
                                        <StyledTableCell>注册用户数</StyledTableCell>
                                        <StyledTableCell>消费累计</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {internalChannelRank?.map(c => <TableRow key={`internal${c.id}`}>
                                        <TableCell>{c.name}</TableCell>
                                        <TableCell>{c.client_count}</TableCell>
                                        <TableCell>{formatPrice(c.sales)}元</TableCell>
                                    </TableRow>)}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Box>
            </Grid>

            <Grid md={6} xs={12}>

                <Box p={1.5}>
                    <Paper >
                        <Box p={1.5} display="flex" justifyContent="space-between" bgcolor="#69A9C7" alignItems="center">
                            <Typography style={{ color: '#fff' }}>外部渠道</Typography>
                            <TextField select InputProps={{ disableUnderline: true }} value={externalMonth} size="small" SelectProps={{ disableUnderline: true, style: { color: '#fff' } }} style={{ color: '#fff' }} onChange={event => setExternalMonth(event.target.value)}>
                                <MenuItem value="this">本月</MenuItem>
                                <MenuItem value="last">上月</MenuItem>
                            </TextField>
                        </Box>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>渠道名称</StyledTableCell>
                                        <StyledTableCell>注册用户数</StyledTableCell>
                                        <StyledTableCell>消费累计</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {externalChannelRank?.map(c => <TableRow key={`internal${c.id}`}>
                                        <TableCell>{c.name}</TableCell>
                                        <TableCell>{c.client_count}</TableCell>
                                        <TableCell>{formatPrice(c.sales)}元</TableCell>
                                    </TableRow>)}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Box>
            </Grid>

        </Grid>
    </React.Fragment>
}

export default Home